import React from "react";

function TermsAndConditions() {
  return (
    <section
      className="terms-conditions-section py-5"
      style={{
        background: "linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)",
        minHeight: "100vh",
      }}
    >
      <div className="container">
        {/* Header */}
        <div className="text-center mb-5">
          <h1 className="display-4 fw-bold text-light mb-3">
            Terms & <span className="text-warning">Conditions</span>
          </h1>
          <p className="lead text-light opacity-75">
            Clear guidelines for our working relationship
          </p>
        </div>

        {/* Main Content */}
        <div className="row g-4">
          {/* Left Column - Process */}
          <div className="col-lg-8">
            <div className="card bg-dark text-light border-warning mb-4">
              <div className="card-body">
                <h3 className="text-warning mb-4">📋 Service Process & Timeline</h3>
                <div className="process-steps">
                  {[
                    {
                      step: "01",
                      title: "Initial Response",
                      desc: "Within 24-48 hours after form submission"
                    },
                    {
                      step: "02",
                      title: "Requirement Collection",
                      desc: "Detailed project specifications gathering"
                    },
                    {
                      step: "03",
                      title: "Agreement Finalization",
                      desc: "Both parties agree to terms and scope"
                    },
                    {
                      step: "04",
                      title: "50% Advance Payment",
                      desc: "Project begins after initial payment"
                    },
                    {
                      step: "05",
                      title: "50% Final Payment",
                      desc: "Upon project completion before delivery"
                    }
                  ].map((item, index) => (
                    <div key={index} className="process-step d-flex mb-4">
                      <div className="step-number bg-warning text-dark rounded-circle d-flex align-items-center justify-content-center me-4" 
                           style={{width: '50px', height: '50px', fontWeight: 'bold'}}>
                        {item.step}
                      </div>
                      <div>
                        <h5 className="text-light">{item.title}</h5>
                        <p className="text-light opacity-75 mb-0">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Services */}
          <div className="col-lg-4">
            <div className="card bg-dark text-light border-info" style={{
              minHeight: "490px",   // card ka minimum height
              maxHeight: "450px",   // optional, zyada bada na ho
              height: "100%",       // flexible height
            }}>
              <div className="card-body">
                <h3 className="text-info mb-4">🚀 Services Offered</h3>
                <div className="services-list">
                  {[
                    "Web Development",
                    "WordPress Development",
                    "E-commerce Solutions",
                    "SEO Services",
                    "Logo Design",
                    "Ads Services",
                  ].map((service, index) => (
                    <div key={index} className="d-flex align-items-center mb-3">
                      <div className="me-3 text-success">✓</div>
                      <span>{service}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Payment Details - Full Width */}
          <div className="col-12">
            <div className="card bg-dark text-light border-success">
              <div className="card-body">
                <h3 className="text-success mb-4">💰 Payment Structure</h3>
                <div className="row">
                  <div className="col-md-6 mb-4 mb-md-0">
                    <div className="payment-card bg-dark p-4 rounded h-100">
                      <h5 className="text-warning mb-3">Advance Payment</h5>
                      <div className="d-flex align-items-center mb-2">
                        <div className="progress flex-grow-1 me-3" style={{height: '10px'}}>
                          <div className="progress-bar bg-warning" style={{width: '50%'}}></div>
                        </div>
                        <span className="fw-bold text-warning">50%</span>
                      </div>
                      <p className="text-light opacity-75 mb-0">
                        Before project initiation
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="payment-card bg-dark p-4 rounded h-100">
                      <h5 className="text-success mb-3">Final Payment</h5>
                      <div className="d-flex align-items-center mb-2">
                        <div className="progress flex-grow-1 me-3" style={{height: '10px'}}>
                          <div className="progress-bar bg-success" style={{width: '50%'}}></div>
                        </div>
                        <span className="fw-bold text-success">50%</span>
                      </div>
                      <p className="text-light opacity-75 mb-0">
                        Upon project completion
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="col-12">
           <div className="alert bg-dark border-warning border-2 mt-4" style={{background: '#1a1a1a'}}>
             <div className="d-flex align-items-center">
              <div className="me-3 text-warning fs-4">⚠️</div>
               <div>
                  <h6 className="text-warning mb-1 fw-bold">Important Note</h6>
                  <p className="mb-0 text-light opacity-90">
                     Bank account details will be provided only after project requirements 
                     are finalized and agreed upon.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      {/* Add this CSS in your App.css or create a separate CSS file */}
      <style jsx>{`
        .terms-conditions-section {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }
        
        .card {
          transition: transform 0.3s ease;
        }
        
        .card:hover {
          transform: translateY(-5px);
        }
        
        .process-step {
          border-left: 2px solid #ffc107;
          padding-left: 15px;
        }
        
        .step-number {
          flex-shrink: 0;
        }
        
        @media (max-width: 768px) {
          .process-step {
            flex-direction: column;
            text-align: center;
            border-left: none;
            border-top: 2px solid #ffc107;
            padding-left: 0;
            padding-top: 15px;
          }
          
          .step-number {
            margin-bottom: 15px;
            margin-right: 0;
          }
        }
      `}</style>
    </section>
  );
}

export default TermsAndConditions;